import { get, isEmpty } from "lodash";
import PrismaSubscriber from "models/data/prisma/PrismaSubscriber";
import PrismaToApiSubscriber from "models/data/mappings/PrismaToApiSubscriber";

class ApiSubscriber {
	static default = {
		id: "",
		email: "",
		referralLink: "",
		numReferred: 0,
		referrer: "",
		sharedStoryLinkQuota: 5
	};

	static id = apiUser => get(apiUser, "id", ApiSubscriber.default.id);

	static email = apiUser => get(apiUser, "email", ApiSubscriber.default.email);

	static referralLink = apiUser => get(apiUser, "referralLink", ApiSubscriber.default.referralLink);

	static numReferred = apiUser => get(apiUser, "numReferred", ApiSubscriber.default.numReferred);

	static referrer = apiUser =>
		get(apiUser, "referrer", ApiSubscriber.default.referrer);

	static sharedStoryLinkQuota = apiUser => get(apiUser, "sharedStoryLinkQuota", ApiSubscriber.default.sharedStoryLinkQuota);

    static async existsWithEmail(email) {
        const subscriber = await ApiSubscriber.fetch(email)
        return !isEmpty(ApiSubscriber.id(subscriber));
    }

	static async fetch(email) {
		const prismaSubscriber = await PrismaSubscriber.fetch(email);
		return PrismaToApiSubscriber.map(prismaSubscriber);
	}
}

export default ApiSubscriber;